import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import api from '~/services/api';
import { isArray } from 'lodash';

import { GFO, GPP } from '~/constants/perfil';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import ConfirmDialog from '../ConfirmDialog';
import { t } from '~/helpers';
import MyForm from './form';
const formRef = createRef();
class GPPConfirmar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      openConfirmarDialog: false,
      openRecusarDialog: false,
      params: {},
    };
  }

  //** */
  ///** processo de confirmar o Recebimento Provisório */
  handleClickConfirmar() {
    this.setState({ openConfirmarDialog: true });
  }
  handleModalConfirmarNAODialog() {
    this.setState({ openConfirmarDialog: false });
  }
  handleModalConfirmarSIMDialog() {
    this.handleConfirmarSubmit();
  }

  async handleConfirmarSubmit() {
    try {
      const desc_codigo = this.state.params.desc_codigo;
      const { profile } = this.props.user;
      const perfil = profile.perfcodigo;
      if (perfil === '6') {
        await api.put('recebimento/gppconfirmar', desc_codigo);
      } else if (perfil === '3') {
        await api.put('recebimento/gfoconfirmar', desc_codigo);
      }
      this.setState({ openConfirmarDialog: false });
      toast.success(t('s.geral.sucessoalteracao'));
      this.handleCloseModal();
      this.props.update();


    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }
      //const validationErrors = {};
    }
  }


  //** */
  ///** processo de RECUSAR o Recebimento Provisório */
  handleClickRecusar() {
    this.setState({ openRecusarDialog: true });
  }
  handleModalRecusarNAODialog() {
    this.setState({ openRecusarDialog: false });
  }
  handleModalRecusarSIMDialog() {
    this.handleRecusarSubmit();

  }

  async handleRecusarSubmit() {
    try {
      const { profile } = this.props.user;

      //const objSend = {
      const desc_codigo = this.state.params.desc_codigo;
      //};

      const perfil = profile.perfcodigo;
      if (perfil === '6') {
        await api.put('recebimento/gpprecusar', desc_codigo);
      } else if (perfil === '3') {
        //await api.put('recebimento/gfoprecusar', desc_codigo);
      }

      this.setState({ openRecusarDialog: false });
      toast.success(t('s.geral.sucessoalteracao'));
      this.handleCloseModal();
      this.props.update();

      //await close();
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }
      //const validationErrors = {};
    }
  }

  // Toggle modal
  async handleToggleModal(params = {}) {
    this.setState((prevState) => ({
      open: !prevState.open,
      params,
    }));
  }

  // Close modal
  async handleCloseModal() {
    //this.setState({ openConfirmDialog: false });
    await this.setState({ open: false });
  }

  verificarConfirmar(params, profile) {
    let retorno = true;
    const perfil = profile.perfcodigo;
    const desc_pendente = params.desc_pendente;
    if (perfil === '6') {

      if (desc_pendente === 'A') {
        retorno = true;
      } else {
        retorno = false;
      }

    } else if (perfil === '3') {
      if (desc_pendente === 'A') {
        retorno = false;
      } else {
        retorno = true;
      }
    } else {
      retorno = true;
    }
    return retorno;
  }


  verificarRecusar(params, profile) {
    let retorno = true;
    const perfil = profile.perfcodigo;
    const desc_pendente = params.desc_pendente;
    if (perfil === '6') {

      if (desc_pendente === 'A') {
        retorno = true;
      } else {
        retorno = false;
      }

    } else {
      retorno = true;
    }
    return retorno;
  }


  render() {
    const { open, openConfirmarDialog, openRecusarDialog, params } = this.state;

    const { profile } = this.props.user;

    return (
      <>
        <Dialog
          open={open}
          maxWidth={'lg'}
          onClose={() => this.handleCloseModal()}
        //fullScreen={window.innerWidth <= 450}
        >
          <DialogTitle>
            {`${params.desc_status_pendencia}`}
          </DialogTitle>
          <DialogContent>
            <MyForm
              data={params}
              reference={formRef}
              close={() => {
                this.handleCloseModal();
                this.props.update();
              }}
            />
          </DialogContent>
          <DialogActions>

            {(profile.gloperfilid !== 1) ?
              <Button
                startIcon={<Check />}
                color="primary"
                variant="outlined"
                //disabled={params.desc_pendente !== 'S'}
                disabled={this.verificarConfirmar(params, profile)}
                onClick={() => this.handleClickConfirmar()}
              >
                Confirmar
            </Button>
              : ''
            }

            {(profile.gloperfilid === 6) ?
              <Button
                startIcon={<Check />}
                color="inherit"
                variant="outlined"
                //disabled={(params.desc_pendente === 'A' && profile.gloperfilid === 3)?true: true }
                disabled={this.verificarRecusar(params, profile)}
                onClick={() => this.handleClickRecusar()}
              >
                Recusar
             </Button>
              : ''
            }

            <Button
              startIcon={<Close />}
              color="secondary"
              variant="outlined"
              onClick={() => this.handleCloseModal()}
            >
              {t('s.geral.botaocancelar')}
            </Button>
          </DialogActions>
        </Dialog>

        <div>

          {/* <IconButton aria-label="delete" onClick={() =>   setConfirmOpen(true)}>
              <DeleteIcon />
            </IconButton>
          */}

          <ConfirmDialog
            title="Confirmar Operação?"
            open={openConfirmarDialog}
            setOpen={() => this.handleModalConfirmarNAODialog()}
            onConfirm={() => this.handleModalConfirmarSIMDialog()}
          >
            Deseja confirmar o recebimento?
          </ConfirmDialog>

          <ConfirmDialog
            title="Recusar Operação?"
            open={openRecusarDialog}
            setOpen={() => this.handleModalRecusarNAODialog()}
            onConfirm={() => this.handleModalRecusarSIMDialog()}
          >
            Deseja cancelar o recebimento?
          </ConfirmDialog>
        </div>
      </>
    );
  }
}

const mapStateToProps = store => ({
  user: store.user
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(GPPConfirmar);
